module.exports = __webpack_public_path__ + "img/xh.855c9dc1.svg";